import { render, staticRenderFns } from "./DDConfirmDetails.vue?vue&type=template&id=b5f295be&scoped=true"
import script from "./DDConfirmDetails.vue?vue&type=script&lang=js"
export * from "./DDConfirmDetails.vue?vue&type=script&lang=js"
import style0 from "./DDConfirmDetails.vue?vue&type=style&index=0&id=b5f295be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f295be",
  null
  
)

export default component.exports